import { Directive, Input, Output, EventEmitter } from '@angular/core';
import { HostListener, HostBinding, Host, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';
export class TdFileSelectDirective {
private _multiple: boolean = false;
/**
 * multiple?: boolean
 * Sets whether multiple files can be selected at once in host element, or just a single file.
 * Can also be 'multiple' native attribute.
 * @param {?} multiple
 * @return {?}
 */
set multiple(multiple: string | boolean) {
    this._multiple = multiple !== '' ? (multiple === 'true' || multiple === true) : true;
  }
/**
 * fileSelect?: function
 * Event emitted when a file or files are selected in host [HTMLInputElement].
 * Emits a [FileList | File] object.
 * Alternative to not use [(ngModel)].
 */
onFileSelect: EventEmitter<FileList | File> = new EventEmitter<FileList | File>();
/**
 * Binds native 'multiple' attribute if [multiple] property is 'true'.
 * @return {?}
 */
get multipleBinding(): string {
    return this._multiple ? '' : undefined;
  }
/**
 * @param {?} model
 */
constructor(
private model: NgModel) {
  }
/**
 * Listens to 'change' host event to get [HTMLInputElement] files.
 * Emits the 'onFileSelect' event with a [FileList] or [File] depending if 'multiple' attr exists in host.
 * Uses [(ngModel)] if declared, instead of emitting 'onFileSelect' event.
 * @param {?} event
 * @return {?}
 */
onChange(event: Event): void {
    if (event.target instanceof HTMLInputElement) {
      let /** @type {?} */ fileInputEl: HTMLInputElement = ( /** @type {?} */((<HTMLInputElement>event.target)));
      let /** @type {?} */ files: FileList = fileInputEl.files;
      if (files.length) {
        let /** @type {?} */ value: FileList | File = this._multiple ? (files.length > 1 ? files : files[0]) : files[0];
        this.model ? this.model.update.emit(value) : this.onFileSelect.emit(value);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdFileSelect]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgModel, decorators: [{ type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'multiple': [{ type: Input, args: ['multiple', ] },],
'onFileSelect': [{ type: Output, args: ['fileSelect', ] },],
'multipleBinding': [{ type: HostBinding, args: ['attr.multiple', ] },],
'onChange': [{ type: HostListener, args: ['change', ['$event'], ] },],
};
}

function TdFileSelectDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdFileSelectDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileSelectDirective.ctorParameters;
/** @type {?} */
TdFileSelectDirective.propDecorators;
/** @type {?} */
TdFileSelectDirective.prototype._multiple;
/**
 * fileSelect?: function
 * Event emitted when a file or files are selected in host [HTMLInputElement].
 * Emits a [FileList | File] object.
 * Alternative to not use [(ngModel)].
 * @type {?}
 */
TdFileSelectDirective.prototype.onFileSelect;
/** @type {?} */
TdFileSelectDirective.prototype.model;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
